module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico-address-84d7f132586987ed99d509284a04d0c0.svg";